// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = require(32);

$export($export.P, 'Array', {copyWithin: require(8)});

require(5)('copyWithin');